import React, { useEffect } from "react";
import Domestic from "../asset/domestic.jpg";
import International from "../asset/international package.jpg";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import { Link, useParams } from "react-router-dom";
import PackageCard from "../components/card/PackageCard";
import AOS from "aos";
import "aos/dist/aos.css";
import { ImgUrl, packageImgUrl } from "../../constant";
import { usePackageTypeDataQuery } from "../../redux/API/PackageApi";

const Package = () => {
  const { id } = useParams();
  const { data: packagesData, isLoading } = usePackageTypeDataQuery(id);
  console.log(packagesData, "packdd");
  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);

  const packageName = packagesData?.packageType?.name;

  
  return (
    <>
      <Navbar />
      <div className="hero_banner">
       
        <img
          src={packagesData?.data[0]?.user?.ptypeId._id === "679a1cf9cf106c76b5337fee" ? International : Domestic}
          alt={packageName}
          className="w-100 h-100"
        />
       
      </div>

      <section className="mt-3 container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/" className="text-success">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {packagesData?.data[0]?.user?.ptypeId.name} Packages
            </li>
          </ol>
        </nav>

        <div className="row mt-3 gy-3">
          <h2 className="text-center">
            {" "}
            {packagesData?.data[0]?.user?.ptypeId.name} Packages
          </h2>

          {!isLoading && packagesData?.data?.map((pkg) => (
            <div className="col-lg-4" data-aos="fade-up" key={pkg?.user?._id}>
              <Link
                to={`/packages/detail/${pkg?.user?.slug}`}
                className="text-decoration-none text-unset"
              >
                <PackageCard
                  title={pkg?.user?.name}
                  location={pkg?.user?.location}
                  price={pkg?.user?.price}
                  img={`${ImgUrl}${packageImgUrl}${pkg?.images[0]}`}
                  days={`${pkg?.user?.days} D/ ${pkg?.user?.days - 1} N`}
                  slug={pkg?.user?.slug}
                />
              </Link>
            </div>
          ))}

          {
            (!isLoading && packagesData?.data?.length === 0 ) && (
              <h6 className="text-center">No Package Found</h6>
            )
          }
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Package;
